import { withOidcSecure } from "@axa-fr/react-oidc";
import CardHeading from "components/CustomComponents/CardHeading";
import DynamicCard from "components/CustomComponents/DynamicCard";
import { width } from "components/CustomComponents/DynamicCard/DynamicCardStyles";
import Loader from "components/CustomComponents/Loader";
import ConfirmationModuleSubItem from "components/Home/AccountServices/Checking/TransferMoney/TransferMoneyConfirm/ConfirmationModuleSubItem";
import logFirebaseEvents from "components/LogFirebaseEvents";
import { appTheme } from "helpers/utils/Utils";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import Accept from "../../../../assets/images/Checkbox-blue.png"
import { displayErrorMessage, displayKudzuplusErrorMessage, retrieveData } from "utils";
import moment from "moment";
import { GetApiHeadersWithBearer, PostRequest } from "network/NetworkUtils";
import { TRANSFER_FUNDS, STATUS_SUCCESS_CODE } from "network/URLConstants";
import React from "react";




const DepositMoneyConfirm = (props) => {

    const { datas, depositFundPayload, onSetStatus, onSetErrorMsg, onCancelSelect } = props
    const { t } = useTranslation();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const [isAccept, setIsAccept] = useState(false);
    const [accpetErrorMessage, setAccpetErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const location = useLocation();


    const accessToken = useSelector(state => state.accessToken);
    const cards = useSelector(state => JSON.parse(state.userCards));


    const depositFund = async () => {
        try {
            setIsLoading(true);
            const date = moment(new Date()).utc().format('l')

            var requestBody = {
                FromAccount: depositFundPayload.FromAccount,
                ToAccount: depositFundPayload.ToAccount,
                FromAccountType: depositFundPayload.FromAccountType,
                ToAccountType: depositFundPayload.ToAccountType,
                Amount: depositFundPayload.Amount,
                Frequency: 'OT',
                TransferDate: date,
                Memo: '',
                IsScheduledTransfer: false
            }

            const deviceId = await retrieveData('updatedDeviceId')

            const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
            const url = TRANSFER_FUNDS.replace('{CARD_KEY}', depositFundPayload.ToAccount);
            const response = await PostRequest(url, requestBody, headers);
            const responseJson = await JSON.parse(response);
            if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
                const ACHTransactionId = responseJson.Response.ACHTransactionId
                const TransactionId = responseJson.Response.TransactionId
                const setTransactionIdObj = ACHTransactionId ? { "achTransactionId": ACHTransactionId } : TransactionId ? { "internalTransactionId": TransactionId } : {}
                if (responseJson?.Response?.ScheduleTransactionId) { setTransactionIdObj.scheduleTransactionId = responseJson?.Response?.ScheduleTransactionId }
                // onSetTransactionId(setTransactionIdObj);
                // props?.setScheduledTransactionId(depositFundPayload, responseJson.Response)
                const fromBalance = responseJson.Response.FromAccountBalance;
                const toBalance = responseJson.Response.ToAccountBalance;
                updateUserCardBalance(fromBalance, toBalance);
                // modalLogic(depositFundPayload?.IsScheduledTransfer);
                onSetStatus("success", 'Spending')
                setIsLoading(false);
                dispatch({ type: "RESET_SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD" })
                dispatch({ type: 'SUCCESSFUL_TRANSFER_RESPONSE', payload: { successfulTransferResponse: responseJson } });

            } else if (responseJson.Messages) {
                // alert(datas[8].value.AccountType);
                setIsLoading(false);
                const isChecking = ["Checking", "Spending"].includes(datas[8].value.AccountType);
                const displayErrorText = responseJson.Messages[0].DisplayText;
                onSetErrorMsg(displayErrorText, isChecking == true ? 'Spending' : 'Savings');
                onSetStatus("error", isChecking == true ? 'Spending' : 'Savings');
                dispatch({ type: "RESET_SECURE_CREDIT_DEPOSIT_MONEY_PAYLOAD" })
            }

        } catch (error) {
            setIsLoading(false);
        }
    }

    const updateUserCardBalance = (fromBalance, toBalance) => {

        const updatedCardData = [...cards]; // Create a copy of the array
        updatedCardData.find(x => x.CardKey == depositFundPayload.FromAccount).Balance = fromBalance;
        updatedCardData.find(x => x.CardKey == depositFundPayload.ToAccount).Balance = toBalance;

        dispatch({ type: 'UPDATE_USER_CARDS', payload: { userCards: JSON.stringify(updatedCardData) } });


        dispatch({ type: 'SUCCESSFUL_TRANSFER_RESPONSE', payload: { successfulTransferResponse: null } });
    }


    const handleConfirm = () => {
        logFirebaseEvents(cardDetails.AccountTypeName + "_" + "Transfer_Money", cardDetails.AccountTypeName + "_" + "Confirm_Clicked", "Confirm_Clicked", "", "");
        if (!isAccept) {
            setAccpetErrorMessage(t('please_select_authorization'));
            return;
        }
        depositFund();
    }

    const handleCancel = () => {
        onCancelSelect(false);
        logFirebaseEvents(
            cardDetails.AccountTypeName + "_" + "Transfer_Money",
            cardDetails.AccountTypeName + "_" + "Cancel_Clicked",
            "Cancel_Clicked",
            "",
            ""
        );
    }

    const children = () => {
        return (

            <>
                <div className={`${kudzuPlusTrue ? '' : ' border-t-[2.5px] border-[#A3CEBB]'}  flex justify-center flex-col  sm:mx-0 mx-4`}></div>
                <p className='pb-6 mt-[50px] font-serif-pro font-[400] lg:text-[26px]
                         md:text-[24px] sm:text-[22px] text-[25px] leading-[32px] 
                   sm:leading-[24px] md:leading-[36px] 
                     text-[var(--transferSubHeading-text)] sm:mx-0 mx-4'>{t("CONFIRM_YOUR_PAYMENT")}</p>


                <div className='flex justify-center sm:mx-0 mx-4'>
                    <div className='sm:w-[80%] w-full'>


                        {datas &&
                            datas.slice(0, 6).map((data) => {
                                return (
                                    <ConfirmationModuleSubItem data={data} />
                                )
                            })
                        }

                        <div
                            className="flex items-start gap-2 pt-12 pb-2 cursor-pointer w-fit"
                            onClick={() => {
                                setAccpetErrorMessage('');
                                setIsAccept((prev) => !prev);
                                logFirebaseEvents(
                                    cardDetails.AccountTypeName + '_' + 'Transfer_Money',
                                    cardDetails.AccountTypeName + '_' + 'Accept_Authority_Clicked',
                                    'Accept_Authority_Clicked',
                                    '',
                                    ''
                                );
                            }}>
                            <button
                                type="button"
                                aria-pressed={!!isAccept}
                                aria-label={t('accept_auth')}
                                className="mt-[2px]"
                            >
                                <img
                                    src={isAccept ? Accept : appThemeData.NotAccept}
                                    alt=""
                                    aria-hidden="true"
                                />
                            </button>

                            <span className="font-hanken-grotesk font-[600]
                            text-[14px] leading-[20px] text-[#2A6DD8]">
                                {t('accept_auth')}
                            </span>
                        </div>

                        <p className={`font-hanken-grotesk text-[16px] leading-[20px] 
                            ${kudzuPlusTrue ? 'text-[var(--text-clr-transactions)]' : 'text-[#262B3A]'}
                             mb-3`}>
                            {t('auth_confirmation')}
                        </p>


                        {accpetErrorMessage &&
                            <div className='mb-2'>
                                {kudzuPlusTrue ? displayKudzuplusErrorMessage(accpetErrorMessage) : displayErrorMessage(accpetErrorMessage)}
                            </div>
                        }


                        <div className="pt-10 pb-20 px-4 sm:px-0 relative z-10 pointer-events-auto">
                            <div
                                className="mx-auto w-full max-w-[360px]
                                sm:max-w-[420px] md:max-w-[520px]
                                lg:max-w-[640px]">
                                    <button type="button"
                                    onClick={handleConfirm} className="w-full h-[56px]
                                        bg-[#2965FB] text-white border-2 border-[#2965FB]
                                        font-hanken-grotesk font-semibold
                                        text-[14px] sm:text-[16px] leading-none
                                        flex items-center justify-center rounded-none
                                        active:scale-[0.99] transition">
                                        {t("CONFIRM_TRANSFER")}
                                    </button>

                                    <button type="button" onClick={handleCancel}
                                        className="mt-6 w-full
                                        text-center font-hanken-grotesk font-medium
                                        text-[12px] sm:text-[14px] text-[#2965FB]">
                                        {t("back")}
                                    </button>
                            </div>
                            </div>
                            
                    </div>

                </div>

            </>
        )
    }

    return (
        <>

            <DynamicCard
                header={false}
                footer={true}
                CardRadius={true}
                cardWidth={width.allpolicies}
                HeaderRadius={true}
                isWhite={appThemeData.isWhiteBgForCard}
                isDarkForKudzu={appThemeData.isDarkBgForCard}
                backgroundColor={'--cardHeading-bg'}
                HeaderContent={
                    <>
                        <CardHeading heading={t('DEPOSIT_FUNDS_HEADER')} />
                    </>
                }
            >
                {children()}
            </DynamicCard>

            {isLoading && <Loader />}
        </>
    )
}

export default withOidcSecure(DepositMoneyConfirm) 